module.exports = __webpack_public_path__ + "img/bg-2.f63d5aa7.png";